import styled from 'styled-components';

import Icon from '../../Icon';

const Container = styled.div`
	height: 100%;
`;

const Section = styled.div`
	position: relative;
	height: 100%;
	float: left;
	margin-right: 16px;
	display: flex;
	align-items: center;

	@media (max-width: 1000px) {
		margin-right: 4px;
	}

	&:nth-last-child(1) {
		margin-right: 0px;
	}
`;

const Title = styled.strong`
  font-size: 20px;
	margin: 0 0 0.25em 0;
	color: #4A4A4A;
	display: block;
	max-width: 450px;
	transition: max-width: 0.2s ease-out;

	@media (max-width: 1700px) {
		max-width: 400px;
	}

	@media (max-width: 1650px) {
		max-width: 300px;
	}

	@media (max-width: 1600px) {
		max-width: 250px;
	}

	@media (max-width: 1500px) {
		max-width: 300px;
	}

	@media (max-width: 1350px) {
		max-width: 200px;
	}

	@media (max-width: 1000px) {
		max-width: 100px;
	}
`;

const TitleInput = styled.input`
	position: absolute;
	top: 0;
	width: 100%;
	border: 0px;
  font-size: 20px;
	margin: 0 0 0.25em 0;
	color: #4A4A4A;
	display: block;

	@media (max-width: 786px) {
		width: 132px;
	}
`;

const Info = styled.p`
  color: #9B9B9B;
  font-size: 14px;
  margin: 0;
`;

const Toggle = styled.div`
	height: 100%;
	background-color: rgba(0,0,0,0);
	border: 0px;
	padding: 8px;
	appearance: none;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-items: center;
	cursor: pointer;
	position: relative;
	text-decoration: none;

	@media (max-width: 1000px) {
		padding: 8px 4px;
	}

	&:hover {
		&:before {
			content: "";
			position: absolute;
			bottom: 0px;
			right: 0px;
			width: 100%;
			height: 2px;
			background-color: #4A90E2;
		}
	}
`;

const ToggleLink = Toggle.withComponent('a');

const ToggleIcon = styled(Icon)`
	margin-bottom: 8px;
	animation: ${props => props.spin === true ? 'spin 0.75s linear infinite' : 'none'};

	@keyframes spin {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(360deg);
		}
	}

	${Toggle}:hover &,
	${ToggleLink}:hover & {
		svg {
			fill: ${props => props.theme.main}
		}
	}
`;
const ToggleName = styled.span`
	font-size: 14px;
	color: #9B9B9B;

	${Toggle}:hover &,
	${ToggleLink}:hover & {
		color: ${props => props.theme.main}
	}
`;

export {
	Container,
	Section,
	Title,
	TitleInput,
	Info,
	Toggle,
	ToggleLink,
	ToggleIcon,
	ToggleName
}
